/**
 * RESPONSIBILITY: draw an event's full-width picture with its words over it.
 *
 * The one band that supplies its own background, which is why it takes `bleed` and why
 * the words sit in a box of their own: text laid straight onto a photograph is legible
 * against the photograph the designer tested and against no other.
 */
import { hasImage } from '@framework/core';
import { Html } from '@framework/react';
import { THEME } from '@app/sections';
import { Band } from './Band';
import { Picture } from '../../commons/Picture';
import type { BandProps } from './kind';

export function Banner({ s }: BandProps) {
  // Every other band disappears when it has nothing; this one drew a placeholder over a
  // gradient, which is a band an editor cannot see the cause of.
  if (!s.heading && !s.bodyHtml && !s.ctaLabel && !hasImage(s.image)) return null;

  return (
    <Band theme={THEME.Banner} bleed>
      <Picture value={s.image} alt="" className="ev-banner-pic" />
      <div className="ev-banner-words">
        {s.heading ? <h2>{s.heading}</h2> : null}
        {s.bodyHtml ? <Html className="md-body">{s.bodyHtml}</Html> : null}
        {s.ctaLabel ? <a className="btn" href={s.ctaHref || '#'}>{s.ctaLabel}</a> : null}
      </div>
    </Band>
  );
}
